export default __webpack_public_path__ + "static/media/Slide26.19e94e90.PNG";